import React from 'react';
import { Grid, Paper, Typography, Button } from '@material-ui/core';
import classnames from 'classnames';
import useStyles from './styles';
import logo from '../../assets/images/logo.svg';

export default function PageErrorBoundary() {
  const classes = useStyles();

  const handleRedirect = () => {
    window.location.reload();
  };

  return (
    <Grid container className={classes.container}>
      <div className={classes.logotype}>
        <img className={classes.logotypeIcon} src={logo} alt="logo" />
        <Typography variant="h3" color="white" className={classes.logotypeText}>
          Content Management System
        </Typography>
      </div>
      <Paper classes={{ root: classes.paperRoot }}>
        <Typography
          variant="h1"
          color="primary"
          className={classnames(classes.textRow, classes.errorCode)}
        >
          Internal Error
        </Typography>
        <Typography variant="h5" color="primary" className={classes.textRow}>
          Oops. Looks like something did not work like we expected.
        </Typography>
        <Typography
          variant="h6"
          color="text"
          colorBrightness="secondary"
          className={classnames(classes.textRow, classes.safetyText)}
        >
          If the problem persists send a message to us.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          to="/"
          size="large"
          className={classes.backButton}
          onClick={handleRedirect}
        >
          Back to Login
        </Button>
      </Paper>
    </Grid>
  );
}
